module.exports = __webpack_public_path__ + "static/media/smart_banner_hero.f1a18fac.png";